export const createIdeaComment = (id, comment) => (dispatch, getState, { api }) => {
  return api.post(`/private/ideaComment/create/general/ideaId/${id}`, comment)
}